import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';
import _ from 'lodash';
import newAlert from '@/payloads/alert.json';
import Feedback from './feedback';

export default Vue.component('admin-dash', {
  template: require('./template.html'),
  name: 'admin-dash',
  mixins: [guid],
  components: {
    Feedback,
  },
  computed: {
    ...mapGetters([
      'websites',
      'users',
      'currentUser',
      'account',
      'identityId',
    ]),
    unread() {
      return _.filter(this.alerts, item => item.status === 'unread').length;
    },
    alerts() {
      return this.account.alerts;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.dispatch('updateRoute', vm.$router.currentRoute.name);
      // if a user was brought here from a re-route, we need to make sure
      // there is a set user or else we route back to login
      if (!vm.identityId) {
        vm.$router.push({ path: '/' });
      }
    });
  },
  data() {
    return {
      openAlerts: false,
      expireDays: 60,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  },
  mounted() {
    this.sweepAlerts();
  },
  methods: {
    async logOut() {
      try {
        await this._cognitoLogout();
        const user = _.clone(window.localStorage.getItem('userCreds'));
        const rememberMe = _.clone(window.localStorage.getItem('rememberMe'));
        localStorage.clear();
        // reset remember me user values to the last user logged in
        window.localStorage.setItem('userCreds', user);
        window.localStorage.setItem('rememberMe', rememberMe);
        // reset local data
        this.$store.dispatch('setWebsites', { websites: [] });
        this.$store.dispatch('setAccount', {});
        this.$store.dispatch('setCurrentUser', false);
        this.$store.dispatch('setUserIdentitiyId', null);
        this.$store.dispatch('setUserSession', { session: {} });
        this.$router.push({ path: '/' });
      } catch (e) {
        this.$store.dispatch('addNotification', {
          id: this.guid(),
          type: 'error',
          message: `${e.message || e}. This has been reported.`,
        });
        await this._reportError({
          error: e,
          fn: 'logOut',
        });
      } finally {
        this._trackEvent({
          type: 'logout',
        });
      }
    },
    runUpdate() {
      this.$log.debug('run function');
    },
    async addAlert() {
      const alert = _.clone(newAlert);
      alert.date = new Date().toISOString();
      alert._id = this.guid();
      alert.fn = 'runUpdate';
      this.$store.dispatch('addAlert', alert);
    },
    runFn(fn) {
      return this[fn]();
    },
    async sweepAlerts() {
      // when alerts get to be too old, we can go ahead and remove them
      // if users have read them
      if (!this.alerts) {
        return;
      }
      const today = new Date();
      const startedAmount = _.clone(this.alerts);
      // hit em with the reverse loop so we don't have index issues
      // deleting as we loop
      for (let i = this.alerts.length - 1; i >= 0; --i) {
        const item = this.alerts[i];
        const age = Math.floor((today - new Date(item.date)) / (1000 * 60 * 60 * 24));
        if (age >= this.expireDays && item.status === 'read') {
          this.$store.dispatch('removeAlert', { ...item, i });
        }
      }

      // only save to dynamo if alerts were removed
      if (this.alerts.length < startedAmount.length) {
        await this.saveAlerts();
      }
    },
    async markAllAsRead() {
      if (this.unread > 0) {
        _.forEach(this.alerts, (item) => {
          this.markAsRead(item);
        });
        await this.saveAlerts();
      }
    },
    async markAsRead(item, save) {
      if (item.status === 'unread') {
        this.$store.dispatch('setAlertStatus', {
          item,
          status: 'read',
        });
        if (save) {
          await this.saveAlerts();
        }
      }
    },
    async saveAlerts() {
      try {
        await this._SEND([{
          name: 'saveAlerts',
          payload: {
            alerts: this.account.alerts,
          },
        }]);
        this.$log.debug('Successfully updated alerts!');
      } catch (e) {
        this.$log.error('error: ', e);
        await this._reportError({
          error: e,
          fn: 'saveAlerts',
        });
      }
    },
    toggleAlerts() {
      this.openAlerts = !this.openAlerts;
    },
    editUser() {
      this.$router.push({ path: '/account' });
    },
    activeClass(type) {
      let cls = '';
      const route = this.$router.currentRoute.meta.root;
      if (route === type) {
        cls = 'adminUi-tab-active';
      }
      return cls;
    },
    filterCrumb(crumb) {
      let c = crumb.meta.breadcrumb;
      if (c.match(/^:/)) {
        c = this.$router.currentRoute.params[c.replace(/^:/, '')];
      }
      if (c === 'Edit Site') {
        c = _.find(this.websites, { _id: this.$route.params.id });
        // if site not found, redirect to websites route
        if (!c) {
          return this.$router.push({ path: '/websites' });
        }
        c = c.alias;
      }
      if (c === 'Edit User') {
        c = _.find(this.users, { _id: this.$route.params.id });
        // if user not found, redirect to users route
        if (!c) {
          return this.$router.push({ path: '/sub-users' });
        }
        c = c.userName;
      }
      return c;
    },
    goToStorm() {
      const path = window.localStorage.getItem('lastStormRoute');
      if (path && path.trim() !== '') {
        this.$router.push({ path });
      } else {
        this.$router.push({ path: '/storm-drzzle-accounts' });
      }
    },
    linkProp(crumb) {
      if (crumb.name || (crumb.handler && crumb.handler.name)) {
        return {
          name: crumb.name || crumb.handler.name,
          params: this.$route.params,
        };
      }
      return {
        path: crumb.handler && crumb.handler.fullPath ? crumb.handler.fullPath : crumb.path,
        params: this.$route.params,
      };
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/index.js